const FAILURE_EVENT = "app:network-failure";
const RESTORED_EVENT = "app:network-restored";

let installed = false;
let failureVersion = 0;

function emit(name, detail = {}) {
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function createSubmissionId(prefix = "submit") {
  const randomPart = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}-${randomPart}`;
}

export function isNetworkError(error) {
  if (!error) return false;
  const message = String(error.message || error).toLowerCase();
  return error.name === "TypeError"
    || error.name === "RequestTimeoutError"
    || error.code === "ERR_NETWORK"
    || message.includes("failed to fetch")
    || message.includes("network error")
    || message.includes("load failed");
}

export async function fetchWithTimeout(input, init = {}, timeoutMs = 30000) {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await window.fetch(input, { ...init, signal: controller.signal });
  } catch (error) {
    if (error?.name === "AbortError") {
      const timeoutError = new Error("زمان انتظار برای اتصال به سرور بیش از حد طولانی شد.");
      timeoutError.name = "RequestTimeoutError";
      failureVersion += 1;
      emit(FAILURE_EVENT, { offline: !navigator.onLine });
      throw timeoutError;
    }
    throw error;
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export function installNetworkMonitor() {
  if (installed || typeof window === "undefined" || typeof window.fetch !== "function") return;
  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const versionAtStart = failureVersion;
    if (!navigator.onLine) {
      emit(FAILURE_EVENT, { offline: true });
    }
    try {
      const response = await originalFetch(...args);
      // A request which started before a newer failure must not hide its warning.
      if (versionAtStart === failureVersion) emit(RESTORED_EVENT);
      return response;
    } catch (error) {
      if (isNetworkError(error)) {
        failureVersion += 1;
        emit(FAILURE_EVENT, { offline: !navigator.onLine });
      }
      throw error;
    }
  };
}

export function networkErrorMessage(error, fallback = "ارسال اطلاعات انجام نشد.") {
  if (!navigator.onLine) return "اتصال اینترنت قطع است. اطلاعات شما حفظ شده؛ پس از اتصال دوباره تلاش کنید.";
  if (isNetworkError(error)) return "ارتباط با سرور برقرار نشد. اطلاعات شما حفظ شده؛ چند لحظه دیگر دوباره تلاش کنید.";
  return error?.message || fallback;
}
